// extracted by mini-css-extract-plugin
export default {"questionMarkIcon":"recover-or-reset_questionMarkIcon__MSsNE","recoverOrResetText":"recover-or-reset_recoverOrResetText__wtD8x","clickHere":"recover-or-reset_clickHere__UUHa2"};